// extracted by mini-css-extract-plugin
module.exports = {"modalTitle":"ExportDocumentAsDocxDialog_modalTitle_SgR4D","title":"ExportDocumentAsDocxDialog_title_1v9Tw","spinAround":"ExportDocumentAsDocxDialog_spinAround_11VIp"};